import { z } from 'zod/v4';

import { endpoint } from '../http/endpoint';
import { TmeCredentialsInputDTORuntype, TmeResponseBodyDTORuntype } from './tmeBackendTypes';

export const tmeEndpoints = {
    'GET /3rdparty/tme/credentials': endpoint({
        description: 'Returns credentials for tme integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: TmeResponseBodyDTORuntype,
    }),
    'POST /3rdparty/tme/credentials': endpoint({
        description: 'Uploads credentials for tme API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: TmeCredentialsInputDTORuntype,
        responseBody: TmeResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/tme/credentials'],
    }),
    'PATCH /3rdparty/tme/credentials': endpoint({
        description: 'Updates credentials for tme API integratoin',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: TmeCredentialsInputDTORuntype,
        responseBody: TmeResponseBodyDTORuntype,
        invalidates: ['GET /3rdparty/tme/credentials'],
    }),
    'DELETE /3rdparty/tme/credentials': endpoint({
        description: 'Deletes existing credentials for tme API integration',
        pathParams: z.undefined(),
        queryParams: z.undefined(),
        requestBody: z.undefined(),
        responseBody: z.object({ deleted: z.number() }),
        invalidates: ['GET /3rdparty/tme/credentials'],
    }),
};
